import { Component, Input, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { DOCUMENT } from '@angular/common';
import { ClassToggleService, HeaderComponent } from '@coreui/angular';
import { AuthService } from 'src/app/auth/auth.service';
import { Environment } from 'src/environments/environment';
import { HeaderService } from 'src/app//helpers/headerService';
@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent {


  @Input() sidebarId: string = "sidebar";

  isDropDownActive = false;

  public newMessages = new Array(4)
  public newTasks = new Array(5)
  public newNotifications = new Array(5)
  userId: string = '';
  userRole: any = [];
  fullName: string = '';
  designation: string = '';
  selectedRole:string = '';
  showDropDown:boolean = true;
  mainRoles: string[] = [ 'IDN', 'AMR']; // Main roles for selection
  filteredRoles: string[] = this.userRole; // Start with all roles displayed
  isADUser: boolean = false;
  logoutConfirmationModal:boolean = false;

  constructor(private classToggler: ClassToggleService, private authService: AuthService, private route: Router, private authMsalService: MsalService,
    private headerService: HeaderService,
    @Inject(DOCUMENT) private document: Document) {
    super();
  }

  ngOnInit() {
    
    const isADUser = localStorage.getItem('isMsal');
    if (isADUser) {
      this.isADUser = JSON.parse(isADUser);
    }
    const role = localStorage.getItem('role');
    if (role) {

      let roles: any = JSON.parse(role);
      this.userRole = roles?.map((obj: any) => obj.roleName);
      let AMR_Index = this.userRole.findIndex((role:any) => role.includes('AMR'))
      let IDN_Index = this.userRole.findIndex((role:any) => role.includes('IDN'))
      if (IDN_Index == -1) {
        let index = this.mainRoles.indexOf('IDN')
        this.mainRoles.splice(index,1)
      }
      if (AMR_Index == -1) {
        let index = this.mainRoles.indexOf('AMR')
        this.mainRoles.splice(index,1)
      }

      if (this.mainRoles.length > 0) {
        const selectedRole = this.mainRoles[0]
        localStorage.setItem('selectedRole', this.mainRoles[0]);
        if(selectedRole){
          this.headerService.updateHeaderStatus(selectedRole);
          this.filteredRoles = this.userRole.filter((role:any) => role.includes(selectedRole));
          this.selectedRole = selectedRole;
          this.showDropDown = this.mainRoles.length > 0;
        }
      }
    }
    const fullName = localStorage.getItem('fullname');
    // const designation = localStorage.getItem('designation');
    const userId = localStorage.getItem('userId');
    this.fullName = fullName || '';
    this.userId = userId || '';

    if (!isADUser) {

      this.designation = localStorage.getItem('healthCareFacilityName') || '';

    }
  }

  viewMemberProfile() {
    if (this.isADUser) {
      this.route.navigate(['/main-forms/cdd-user-management/view-user', this.userId])
    } else {
      this.route.navigate(['/dashboard/facility-member/facility-member-profile-view', this.userId])
    }
  }
    // Function to handle role selection change
    onRoleChange(event: any) {
      let selectedRole = event.target.value
      this.filteredRoles = this.userRole.filter((role:any) => role.includes(selectedRole));
      localStorage.setItem('selectedRole', selectedRole);
      this.headerService.updateHeaderStatus(selectedRole);
      if (selectedRole == 'IDN') {
        if (localStorage.getItem('healthCareFacilityName')) {
          this.route.navigate(['/dashboard/idn-notifications']);
        } else {
          this.route.navigate(['/main-forms/case-view-form'])
        }
      } else if (selectedRole == 'AMR') {
        if (localStorage.getItem('healthCareFacilityName')) {
          this.route.navigate(['/dashboard/amr-files']);
        } else {
          this.route.navigate(['/dashboard/amr-case-management'])
        }
      } 
    }

  onLogOut() {
    if (localStorage.getItem('isMsal') && localStorage.getItem('php') != "true") {
      localStorage.clear();
      sessionStorage.clear();
      this.authMsalService.logoutRedirect({ postLogoutRedirectUri: '/' });
    } else if (localStorage.getItem('php') == "true") {
      localStorage.clear();
      sessionStorage.clear();
      this.document.location.href = Environment.phpConfig.auth.logoutUri
    } else {
      let uaepasssignouturl = `${Environment.uaePassConfig.url}logout?redirect_uri=${Environment.uaePassConfig.redirect_url}`;
      localStorage.clear();
      sessionStorage.clear();
      this.authService.logout();
      this.document.location.href = uaepasssignouturl;
      //this.route.navigate(['/login'])
    }
  }
  /* ends here */

  dropdownlist() {
    this.isDropDownActive = true;
  }
  logoutConfirmationModalReq() {
    this.logoutConfirmationModal = true;
  }

  rejectLogoutRequest() {
    this.logoutConfirmationModal = false;
  }
}
